import React, { useEffect } from 'react';
import { AuthProvider as OidcAuthProvider, useAuth } from 'react-oidc-context';
import { oidcConfig, validateOidcConfig, debugOidcConfig } from '../lib/config/oidcConfig';

interface AuthProviderProps {
  children: React.ReactNode;
}

const AuthEventHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useAuth();

  useEffect(() => {
    if (import.meta.env.DEV) {
      debugOidcConfig();
    }
  }, []);

  useEffect(() => {
    if (auth.error) {
      console.error('OIDC Authentication Error:', auth.error);
    }
  }, [auth.error]);

  useEffect(() => {
    if (auth.isAuthenticated && auth.user) {
      console.log('User authenticated:', auth.user.profile.preferred_username);
    }
  }, [auth.isAuthenticated, auth.user]);

  return <>{children}</>;
};

const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  if (!validateOidcConfig()) {
    console.error('OIDC configuration validation failed');
  }

  return (
    <OidcAuthProvider {...oidcConfig}>
      <AuthEventHandler>
        {children}
      </AuthEventHandler>
    </OidcAuthProvider>
  );
};

export default AuthProvider;
